import { makeAutoObservable } from "mobx";

import { Notification, NotificationReportCommand } from "api";

export class NotificationGlobalStore {
  activeNotifications: Notification[] = [];
  showNotesModal = false;
  showReportModal = false;

  constructor() {
    makeAutoObservable(this);
  }

  setActiveNotifications = (notifications: Notification[] = []) => {
    this.activeNotifications = notifications;
  };

  get emptyReportCriteria(): NotificationReportCommand {
    return {
      startDate: undefined,
      endDate: undefined,
      includeResolved: false,
    };
  }
}
